import Box from "@mui/material/Box";
import { lazy, Suspense } from "react";
import Stack from "@mui/material/Stack";
import MainCard from "../Layouts/MainCard";
import ExerciseEntity from "./ExerciseEntity";
import { Theme } from "../../data/style/Theme";
import { useQuery } from "@tanstack/react-query";
import { getAthleteLifts } from "../../api/user";
import { useAuth } from "../../context/AuthContext";
import useScreenSize from "../../context/ScreenContext";
import TableChartIcon from "@mui/icons-material/TableChart";
import {
  scrollBar,
  SpacedRow,
  MainText,
  MainTitle,
  CenteredRow,
} from "../../data/style/Style";

const Loader = lazy(() => import("./Loader"));
const NoDataDiv = lazy(() => import("./NoDataDiv"));
const AbilitiesModal = lazy(() => import("../Modals/AblitiesModal"));

const Lifts = ({ showExerciseDetails }) => {
  const { user } = useAuth();
  const { mobileDevice } = useScreenSize();

  const { data, isPending } = useQuery({
    queryKey: ["abilities", "weightlifting", user.id],
    queryFn: ({ signal }) => getAthleteLifts({ signal }),
    staleTime: 30 * 60 * 1000,
  });

  return (
    <Box flex={1} minWidth={"270px"}>
      <MainCard start={Theme.palette.silver} middle={Theme.palette.silver}>
        {!isPending ? (
          <>
            <SpacedRow alignItems={"center"}>
              <CenteredRow gap={1}>
                <MainText fontSize={"1.2rem"}>🏋</MainText>
                <MainTitle mobile={mobileDevice}>Weightlifting</MainTitle>
              </CenteredRow>
              <Suspense>
                <AbilitiesModal
                  type={"weightlifting"}
                  color={Theme.palette.silver}
                />
              </Suspense>
            </SpacedRow>
            {data.length > 0 ? (
              <Stack p={0.5} height={"30vh"} sx={scrollBar} overflow={"auto"}>
                {data.map((item) => (
                  <ExerciseEntity
                    key={item.id}
                    item={item}
                    showExerciseDetails={showExerciseDetails}
                    type={"weightlifting"}
                  />
                ))}
              </Stack>
            ) : (
              <Suspense>
                <NoDataDiv
                  height={"30vh"}
                  minHeight={"160px"}
                  icon={
                    <TableChartIcon
                      sx={{
                        fontSize: mobileDevice ? "3rem" : "4rem",
                        color: Theme.palette.silver,
                      }}
                    />
                  }
                  text={"No data available. Start tracking your progress."}
                />
              </Suspense>
            )}
          </>
        ) : (
          <Suspense>
            <Loader height={"35vh"} minHeight={"100px"} />
          </Suspense>
        )}
      </MainCard>
    </Box>
  );
};

export default Lifts;
